import React from 'react';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Confirmar', }) => {
  if (!isOpen) return null;

  return (
    <div className="modal_overlay" onClick={(e) => {
      if (e.target.className === 'modal_overlay') onClose();
    }}>
      <div className="modal_content confirm_modal">
        <div className="modal_content_header">
          <span onClick={onClose} className="modal_content_header_close"></span>
        </div>
        <div className="modal_content_body text-center">
         <svg width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_29_1115)"><path d="M12.63 29.1987H4.42927C2.93659 29.1987 1.72265 27.9294 1.72265 26.3685V4.63146C1.72265 3.07063 2.93659 1.80128 4.42927 1.80128H12.63C13.1052 1.80128 13.4913 1.3976 13.4913 0.900642C13.4913 0.403686 13.1052 0 12.63 0H4.42927C1.98676 0 0 2.07745 0 4.63146V26.3685C0 28.9225 1.98676 31 4.42927 31H12.63C13.1052 31 13.4913 30.5963 13.4913 30.0994C13.4913 29.6024 13.1052 29.1987 12.63 29.1987Z" fill="#010101"></path><path d="M29.9982 15.0537V15.045C30.0073 14.7914 29.9181 14.5531 29.7466 14.3739L22.709 7.015C22.5466 6.84522 22.3299 6.75122 22.0999 6.75122C21.87 6.75122 21.6532 6.84522 21.4909 7.015C21.155 7.36622 21.155 7.9375 21.4909 8.28872L27.1466 14.2026H7.14941C6.67415 14.2026 6.28809 14.6063 6.28809 15.1033C6.28809 15.6002 6.67415 16.0039 7.14941 16.0039H27.0728L21.4916 21.8399C21.3292 22.0097 21.2393 22.2363 21.2393 22.4767C21.2393 22.7172 21.3292 22.9438 21.4916 23.1136C21.8275 23.4648 22.3738 23.4648 22.7097 23.1136L29.7473 15.7547C29.9097 15.5849 29.9996 15.3583 29.9996 15.1179V15.1026C29.9996 15.0902 29.9996 15.0763 29.9989 15.0632V15.0545L29.9982 15.0537Z" fill="#010101"></path></g><defs><clipPath id="clip0_29_1115"><rect width="30" height="31" fill="white"></rect></clipPath></defs></svg>
         <h3 className="ppt_form_title my-4">{message}</h3>
          <div className="d-flex justify-content-center gap-3">
            <button
              className="ppt_btn_primary alt"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;